import { Component } from '@angular/core'

@Component({
  template: '<ftr-courtroom-display></ftr-courtroom-display>',
})
export class CourtroomDisplayPage {
  constructor() {
    //
  }
}
